import { defineStore } from 'pinia';
import Auth from '@/utils/auth';
import PortalAuth from '@/utils/portalAuth';
import { login, smslogin, logout, getInfo, wechatRegister, singleLoginZdcloud } from '@/api/login';
// import { useRouter } from '@/utils/router';
import { productInfo } from './productInfo';
import { appInfo } from './appInfo';

export const userInfo = defineStore('userInfo', {
  state: () => {
    return {
      token: Auth.getToken(),
      portalToken:PortalAuth.getToken(),
      roles: [],
      permissions: [],
      name: '',
      companyId: '',
      avatar: '',
      email: '',
      nickName: '',
      phonenumber: '',
      tenantId: '',
      userId: '',
      userIdentity: undefined,
      userName: '',
      /**企业id */
      hostId: '',
      unReadMsgNum: 0,
      enterpriseName: '',
      mark: '',
      userLevel: '',
      levelName: '',
      //默认智电云内部id
      defaultHostId: '1599925752872718336',
    };
  },
  getters: {
    /**是否为主企业 */
    isMaster: state => state.companyId === state.hostId,
    // 是否登录
    isLogin: state => !!state.userId,
    // 是否为供应商 roles 包含selfMallSupplier
    isSupplier: state => state.roles.includes('innerMallSupplier'),
    // 是否为经销商
    isDealer: state => state.roles.includes('enterpriseCenter'),
    // 是否现实经销商商城
    isShowDealer: state => state.defaultHostId === state.hostId,
  },
  actions: {
    // 设置token
    setToken(token) {
      Auth.setToken(token);
      this.token = token;
    },
    // 获取门户 token 并保存到 cookie
    getZdCloudToken() {
      const that=this
      return new Promise((resolve, reject) => {
        singleLoginZdcloud()
          .then(res => {
            const data = res.data;
            if (data && data.access_token) {
              PortalAuth.setToken(data.access_token);
              that.portalToken = data.access_token;
            }
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 登录
    Login(userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password;
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid)
          .then(res => {
            const data = res.data;
            Auth.setToken(data.access_token);
            this.token = data.access_token;
            // 登录成功后获取门户 token
            this.getZdCloudToken()
              .then(() => {
                resolve({});
              })
              .catch(() => {
                // 即使获取门户 token 失败也不影响正常登录流程
                resolve({});
              });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //验证码登录
    codeLogin(userInfo) {
      const phone = userInfo.phonenumber.trim();
      const code = userInfo.code;
      return new Promise((resolve, reject) => {
        smslogin(phone, code)
          .then(res => {
            const data = res.data;
            Auth.setToken(data.access_token);
            this.token = data.access_token;
            // 登录成功后获取门户 token
            this.getZdCloudToken()
              .then(() => {
                resolve({});
              })
              .catch(() => {
                // 即使获取门户 token 失败也不影响正常登录流程
                resolve({});
              });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //微信登录
    wechatLogin(token) {
      return new Promise((resolve, reject) => {
        Auth.setToken(token);
        this.token = token;
        // 登录成功后获取门户 token
        this.getZdCloudToken()
          .then(() => {
            resolve({});
          })
          .catch(() => {
            // 即使获取门户 token 失败也不影响正常登录流程
            resolve({});
          });
      });
    },
    //微信绑定注册
    wechatBind(data) {
      return new Promise((resolve, reject) => {
        wechatRegister(data)
          .then(res => {
            const data = res.data;
            Auth.setToken(data.access_token);
            this.token = data.access_token;
            // 登录成功后获取门户 token
            this.getZdCloudToken()
              .then(() => {
                resolve({});
              })
              .catch(() => {
                // 即使获取门户 token 失败也不影响正常登录流程
                resolve({});
              });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //获取用户信息
    GetInfo() {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            const user = res.user;
            const avatar = user.avatar == user.avatar;
            if (res.roles && res.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              this.roles = res.roles;
              this.permissions = res.permissions;
            } else {
              this.roles = ['ROLE_DEFAULT'];
            }
            this.name = user.name;
            this.companyId = user.companyId;
            this.avatar = user.avatar;
            this.email = user.email;
            this.nickName = user.nickName;
            this.phonenumber = user.phonenumber;
            this.tenantId = user.tenantId;
            this.userId = user.userId;
            this.userIdentity = user.userIdentity;
            this.userName = user.userName;
            this.hostId = user.hostId;
            this.enterpriseName = user.enterpriseName;
            this.mark = user.hostDisplayName;
            this.userLevel = user.userLevel;
            this.levelName = user.levelName;

            if (user.isMaster == 1) {
              this.roles.push('MASTER');
            }
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 退出系统
    LogOut() {
      const productStores = productInfo();
      const appstore = appInfo();
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            this.clearUserInfo();
            productStores.shoppingcartNum = 0;
            Auth.removeToken();
            Auth.removeTokenByKey('ZdClound-Token');
            // 主动退出清空 redirctUrl ,防止不同角色登录跳转到404
            appstore.redirectUrl = '';
            appstore.isRedirectUrl = false;
            resolve({});
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    clearUserInfo() {
      this.token = '';
      this.roles = [];
      this.permissions = [];
      this.name = '';
      this.companyId = '';
      this.avatar = '';
      this.email = '';
      this.nickName = '';
      this.phonenumber = '';
      this.tenantId = '';
      this.userId = '';
      this.userIdentity = '';
      this.userName = '';
      this.enterpriseName = '';
      this.mark = '';
      this.userLevel = '';
      this.levelName = '';
      this.hostId = '';
      this.unReadMsgNum = 0;
    },
    //设置未读消息
    setunReadMsgNum(num) {
      this.unReadMsgNum = num;
    },

    // 获取积分信息
  },
});

export default userInfo;
